import { HttpErrorResponse } from '@angular/common/http';
import { OnChanges } from '@angular/core';
import { Input, SimpleChanges } from '@angular/core';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { errorMessages, otpOption, userType } from 'src/app/constants/global-constants';
import { ILogin, ILoginResponse, INewPassword, IOTPdata, IUser, IUserData, IUserEmail, IVerifyOtp } from 'src/app/models/auth.models';
import { IGenericResponse } from 'src/app/models/shared.models';
import { OtpInputComponent } from 'src/app/pages/shared-components/otp-input/otp-input.component';
import { AuthService } from 'src/app/services/auth.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
declare var $: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  eye : boolean = true;
  @ViewChild("pass") pass: ElementRef;

  loading = false;

  @Input() otpData:IOTPdata;
  @Input() user:IUser;                  // Will be passed from forgot password modal

  @ViewChild('phoneOtp') phoneOtp : OtpInputComponent;
  @ViewChild('emailOtp') emailOtp : OtpInputComponent;
  @ViewChild('forgotPassOtp') forgotPassOtp : OtpInputComponent;

  otpOption = otpOption;
  selectedOtpOption = otpOption.EMAIL;

  /* FLag for respective Invalid OTP */
  invalidPhoneOtp = false;
  invalidEmail = false;
  invalidForgetPassOtp = false;

  /* Flags to disable button in respective modals*/
  sendOtpBtn = false;
  resendLinkDisable = false;
  emailResendLinkDisable = false;
  verifyButton = false;

  newPassword: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar:SnackbarService) { }

  ngOnInit(): void {

  }

  navigateToLoginModal(){
    $('#create-password-modal').modal('hide');
    $('#change-password-option-modal').modal('hide');
    $('#password-reset-success-modal').modal('hide');
    $('#verify-email-mobile-modal').modal('hide');
    $('#login-modal').modal('show');
    this.resetOtp();
  }

  navigateToSignupForm(){
    this.resetOtp();
    $('#verify-email-mobile-modal').modal('hide');
    if(this.otpData.userType == userType.MUM){
      $('#signup-modal-pregnant').modal('hide');
    }
    else{
      $('#signup-modal-midwife-2').modal('show');
    }
  }

  navigateToSignupMidwife(){
    $('#login-modal').modal('hide');
    $('#signup-modal-midwife-1').modal('show');
    this.resetOtp();
  }

  chooseVerifyOptionModal(){
    $('#verify-otp-modal').modal('hide');
    $('#change-password-option-modal').modal('show');
  }

  sendOtpModal(){
    $('#change-password-option-modal').modal('hide');
    $('#create-password-modal').modal('hide');
    $('#verify-otp-modal').modal('show');
  }

  verifyOtpModal(){
    this.resetOtp();
    $('#verify-otp-modal').modal('hide');
    $('#password-reset-success-modal').modal('hide');
    $('#create-password-modal').modal('show');
  }

  toggle(){
    this.eye = !this.eye;
    this.pass.nativeElement.type = this.eye ? "password" : "text";
  }

  sendPhoneOTP(signUp:boolean = false){
    this.sendOtpBtn = true;
    var data:any = {};

    if(signUp){
      data["userPhonenumber"]=this.otpData.userPhonenumber
      this.resendLinkDisable = true;
    }
    else{
      data["userPhonenumber"] = this.user.userPhonenumber
    }

    this.authService.requestOtpPhone(data)
    .subscribe(
      (res:IGenericResponse) => {
        console.log("Phone OTP Sent :",res);
        this.loading = false;
        this.sendOtpBtn = false;
        this.resendLinkDisable = false;
        this.snackBar.openSnackBar(this.getErrorMessage(res.errorMessage))

        if(!signUp){
          this.sendOtpModal();
        }
      },
      (err:HttpErrorResponse) => {
        console.error(" Phone OTP API error :",err);
        this.loading = false;
        this.resendLinkDisable = false;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
      }
    );
  }

  sendEmailOTP(signUp:boolean=false){
    this.sendOtpBtn = true;
    var data:any = {};

    if(signUp){
      data["userEmail"]=this.otpData.userEmail
      this.emailResendLinkDisable = true;
    }
    else{
      data["userEmail"] = this.user.userEmail
    }

    this.authService.requestOtpEmail(data)
    .subscribe(
      (res:IGenericResponse) =>   {
        console.log("Email OTP Sent :",res);
        this.loading = false;
        this.sendOtpBtn = false;
        this.resendLinkDisable = false;
        this.emailResendLinkDisable = false;
        this.snackBar.openSnackBar(this.getErrorMessage(res.errorMessage))

        if(!signUp){
          this.sendOtpModal();
        }
      },
      (err:HttpErrorResponse) => {
        console.error(" Email OTP API error :",err);
        this.loading = false;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
        this.sendOtpBtn = false;
        this.resendLinkDisable = false;
        this.emailResendLinkDisable = false;
      }
    );
  }

  verifyEmailOtp(otp:string){
    this.loading = true;
    this.verifyButton = true;
    this.invalidForgetPassOtp = false;

    var data:any = {
      'userEmail':this.user.userEmail,
      'otpEmail':otp
    };

    this.authService.verifyOtpEmail(data)
    .subscribe(
      (res:IGenericResponse) =>   {
        console.log("Verified Email OTP Sent :",res);
        this.loading = false;
        this.verifyButton = false;
        this.verifyOtpModal();
      },
      (err:HttpErrorResponse) => {
        console.error("Verify Email OTP API error :",err);
        this.invalidForgetPassOtp = true;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
        this.invalidForgetPassOtp = true;
        this.loading = false;
        this.verifyButton = false;
      }
    );
  }

  verifyPhoneOtp(otp:string){
    this.loading = true;
    this.invalidForgetPassOtp = false;
    this.verifyButton = true;
    var data:any = {
      'userEmail':this.user.userEmail,
      'otpPhone':otp
    };

    this.authService.verifyOtpPhone(data)
    .subscribe(
      (res:IGenericResponse) =>   {
        console.log("Verified Phone OTP Sent :",res);
        this.loading = false;
        this.verifyButton = false;
        this.resetOtp();
        this.verifyOtpModal();
      },
      (err:HttpErrorResponse) => {
        console.error("Verify Phone OTP API error :",err);
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
        this.invalidForgetPassOtp = true;
        this.loading = false;
        this.verifyButton = false;
      }
    );
  }

  verifyBothOtps(otps:IVerifyOtp){
    this.invalidPhoneOtp = false;
    this.invalidEmail = false;

    this.authService.verifyOtpBoth(otps)
    .subscribe(
      (res:IGenericResponse) => {
        console.log("OTP Verifcation Successful :",res);
        this.verifyButton = false;
        this.login();
        this.resetOtp();
      },
      (err:HttpErrorResponse) => {
        console.error(" Verify Both API error :",err);
        this.verifyButton = false;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))

        if(err.status == 402){
          if(err.error.errorMessage.toLowerCase().includes("phone")){
            this.invalidPhoneOtp = true;
          }
          if(err.error.errorMessage.toLowerCase().includes("email")){
            this.invalidEmail = true;
          }
        }
      }
    );
  }

  confirmSignUpOtp(){
    var otps:IVerifyOtp = {
      "otpPhone":this.phoneOtp.otpValue(),
      "otpEmail":this.emailOtp.otpValue(),
      "userEmail":this.otpData.userEmail
    }
    console.log("OTPs recieved ",otps);

    if(otps.otpEmail && otps.otpPhone){
      this.verifyButton = true;
      this.verifyBothOtps(otps);
    }

  }

  confirmPasswordOtp(){
    var otp = this.forgotPassOtp.otpValue();
    if(otp){
      if(this.selectedOtpOption == otpOption.EMAIL){
        this.verifyEmailOtp(otp);
      }
      else{
        this.verifyPhoneOtp(otp);
      }
    }
  }

  sendPasswordOtp(){
    this.loading = true;
    this.resendLinkDisable = true;
    if(this.selectedOtpOption == otpOption.EMAIL){
      this.sendEmailOTP();
    }
    else{
      this.sendPhoneOTP();
    }
  }

  login(){
    var password = localStorage.getItem('signupUser');
    var loginData:ILogin = {
      userEmail: this.otpData.userEmail,
      userHashPassword: password ? password : "",
      device: '',
      userType: '',
    }

    this.authService.login(loginData)
    .subscribe(
      (res:ILoginResponse)=>{
        console.log("Logged In ", res);
        this.authService.storeToken(res.user.authToken);
        this.authService.storeUserInfo(res.user);
        $('#verify-email-mobile-modal').modal('hide');
        this.router.navigate(['/dashboard']);
        this.loading = false;
      },
      (err:any)=>{
        console.error("Login API Error", err);
        this.loading = false;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
      }
    );
  }

  /*  This will used to set otp option  */
  onSelectOtpOption(otpOption:string){
    console.log("Selected OTP Method :",otpOption);
    this.selectedOtpOption = otpOption;
  }

  getErrorMessage(errorMessage?:string){
    if (errorMessage){
      return errorMessage;
    }
    return errorMessages.SOMETHING_WENT_WRONG
  }

  resetOtp(){
    this.forgotPassOtp.resetOtpValue();
    this.emailOtp.resetOtpValue();
    this.phoneOtp.resetOtpValue();
  }

  resetPassword(){
    this.loading = true;
    var userData: INewPassword = {
      userEmail : this.user.userEmail,
      newHashPassword: this.newPassword
    };

    this.authService.resetPassword(userData)
    .subscribe(
      (res:IUserData)=>{
        console.log("Password Reset Successful !", res);
        $('#create-password-modal').modal('hide');
        $('#password-reset-success-modal').modal('show');
        this.loading = false;
        this.newPassword = '';
      },
      (err:any)=>{
        console.error("Reset Password API Error", err);
        this.loading = false;
        this.snackBar.openSnackBar(this.getErrorMessage(err.error.errorMessage))
      }
    );
  }

}
